function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IboxChecked = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.4286 24H2.57143C1.15125 24 0 22.8488 0 21.4286V2.57143C0 1.15125 1.15125 0 2.57143 0H21.4286C22.8488 0 24 1.15125 24 2.57143V21.4286C24 22.8488 22.8488 24 21.4286 24ZM10.4632 18.7468L20.3204 8.8897C20.6551 8.55498 20.6551 8.01225 20.3204 7.67754L19.1082 6.46537C18.7735 6.13066 18.2308 6.13061 17.896 6.46537L9.85714 14.5042L6.10398 10.751C5.76927 10.4163 5.22654 10.4163 4.89177 10.751L3.67961 11.9632C3.34489 12.2979 3.34489 12.8406 3.67961 13.1754L9.25104 18.7468C9.5858 19.0816 10.1285 19.0816 10.4632 18.7468V18.7468Z",
    fill: "black"
  }));
});